// External Stuff
import React from 'react';

function Blog(props) {
	return (
		<div className='body-container'>
			<h1>Blog Page Heading!</h1>
			<h2>Blog Page Subheading</h2>
			<p>Blog Page Content Goes Here</p>
		</div>
	);
}

export default Blog;
